var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editor",staticClass:"vp-editor"},[((_vm.vpContent === '' || _vm.vpContent === '<br>') && _vm.placeholder)?_c('div',{staticClass:"vp-editor__placeholder",on:{"click":function($event){_vm.$refs.editor.content.focus()}}},[_vm._v("\n    "+_vm._s(_vm.placeholder)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad600f8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-pell-editor/src/js/editor.vue
// module id = B505
// module chunks = 8